import { FrontierService } from '@api';
import { useAppQuery } from '@api/query/use-app-query';
import { InventoryQueryKeys } from '@Inventory/services/queryKeys';
import { InventoryFilterInput } from '@api/gql/graphql';
import { inventoryCountsDocument } from './use-inventory-counts.gql';

export function useInventoryCounts(filter: InventoryFilterInput, enabled = true) {
  const fetch = async () =>
    FrontierService.request(inventoryCountsDocument, {
      filter,
    });

  return useAppQuery([InventoryQueryKeys.InventoryCounts, JSON.stringify({ filter })], fetch, {
    keepPreviousData: true,
    enabled,
  });
}
